
<template>
  <div class="main-container">
    <div class="title-container">
      <div class="title">
        <span class="title-text">联系作者</span>
      </div>
      <div class="page-remark">
        <span class="remark-text"
          >欢迎讨论
        </span>
      </div>
    </div>
    <div class="main-content">
      <span>欢迎联系讨论</span>
     <el-divider border-style="dashed" />
     <p>QQ：190682222</p>
     <p>邮箱：190682222@qq.com</p>
     <p>微信：138880565828</p>
    </div>  
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import { reactive, getCurrentInstance, ref, watch } from "vue";


export default defineComponent({
 
  emits:['login'],
  setup(props, context) {
    console.log(props);
    let { proxy } = getCurrentInstance();
    const dialogLoginVisible = ref(false);
    let result = ref(String);
    result.value = "";

    let solution = reactive({
      pnrContent: "",
      remark: "",
      totalTicket: 0,
      addMoneyTicket: 0,
      addPercentTicket: 0,
      addMoneyRefund: 0,
      addPercentRefund: 0,
      addMoneyChange: 0,
      addPercentChange: 0,
      test: "wanghuixiong",
    });

    function login(show){
      dialogLoginVisible.value = show;
    }

    /**
     * 转换方案
     */
    function translate() {
      if (solution.pnrContent === "") {
        return;
      }
      // console.log(solution);
      proxy.$http.post("/solution/translate", solution).then((Response) => {
        console.log(Response);
        if (Response === "FORBIDDEN") {
          // console.log("true");
          // console.log(dialogLoginVisible.value);
          // dialogLoginVisible.value = true;
          context.emit('login')
          return;
        }
        result.value = Response;
      });
    }

    function openVideo() {
      this.$router.push("/video");
    }

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyTicket,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addPercentTicket = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentTicket,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addMoneyTicket = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyRefund,
      (newVal) => {
        solution.addMoneyChange = newVal;
        if (newVal === 0) {
          return;
        }
        solution.addPercentRefund = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentRefund,
      (newVal) => {
        solution.addPercentChange = newVal;
        if (newVal === 0) {
          return;
        }
        solution.addMoneyRefund = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyChange,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addPercentChange = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentChange,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addMoneyChange = 0;
      }
    );

    return { solution, translate, result, openVideo, dialogLoginVisible,login };
  },
});
</script>
<style lang="scss" scoped>
.main-container {
  margin: -24px -24px 0 -24px;
}
.title-container {
  padding: 12px 24px 16px 24px;
  background-color: #fff;
}
.title {
  height: 40px;
  padding: 8px 0px 0px 0px;
}
.title-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.page-remark {
  padding: 12px, 0px, 0px, 0px;
}
.remark-text {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.main-content {
  margin: 24px;
  padding: 24px;
  background-color: #fff;
}
.content-row {
  margin-bottom: 16px;
}
table,
th,
td {
  widows: 100%;
  border-collapse: collapse;
  border-color: #d3dce6;
  border-width: 1px;
  border-style: solid;
  height: 36px;
}
.price-table-col {
  border-color: #d3dce6;
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  height: 36px;
  padding: 0px 2px;
}
.td-title {
  background-color: #fafafa;
}
.table-title {
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  padding: 4px;
}
.table-first-col {
  min-width: 40px;
}


// /deep/.el-input__inner {
//   text-align: right;
// }
</style>
